//@ts-nocheck
import { axiosGroup } from ".";

export const getAllSellTransactions = async () => {
  const items = await axiosGroup.axiosServer.get("/user/collection/selling");
  
  // Flatten the nested NFTs array and format each transaction
  const transactions = items.data.flatMap((collection: any) => 
    collection.nfts.map((nft: any) => ({
      id: nft.id,
      txId: nft.id,
      hash: nft.id,
      time: new Date(nft.createAt._seconds * 1000).toISOString(),
      type: "Deposit",
      status: nft.status,
      talAmount: `${nft.amount} TAL`,
      paymentMethod: "Bank credit card",
      receiverWallet: collection.ownerId,
      metadata: nft.metadata
    }))
  );

  return transactions;
};
export const getAllNFT = async () => {
  const items = await axiosGroup.axiosServer.get("/user/collection");
  
  // Flatten the nested NFTs array and format each transaction
  const transactions = items.data.flatMap((collection: any) => 
    collection.nfts.map((nft: any) => ({
      id: nft.id,
      txId: nft.id,
      hash: nft.id,
      time: new Date(nft.createAt._seconds * 1000).toISOString(),
      type: "Deposit",
      status: nft.status,
      talAmount: `${nft.amount} TAL`,
      paymentMethod: "Bank credit card",
      receiverWallet: collection.ownerId,
      metadata: nft.metadata
    }))
  );

  return transactions;
};

export const updateSellTransaction = async (data: any) => {
  await axiosGroup.axiosServer.patch("/sellTransaction", {
    ...data,
  });
};
